export default __webpack_public_path__ + "static/media/pic9.37dbadb0.jpg";